import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '@/views/Login.vue'
import TemplateDownload from '@/views/TemplateDownload.vue'
import GeoForecast from '@/views/GeoForecast.vue'

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  { path: '/download', component: TemplateDownload },
  { path: '/forecast', component: GeoForecast }
]
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

async function getDocTag(): Promise<string> {
  try {
    return await Word.run(async (context) => {
      const props = context.document.properties
      props.load(['keywords'])
      await context.sync()
      return props.keywords || ''
    })
  } catch {
    return ''
  }
}

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')
  const isInitialLoad = from.matched.length === 0

  if (!token) {
    if (to.path === '/login') {
      next(); // 明确调用，代表放行
    } else {
      next('/login'); // 明确重定向
    }
  }
  if (isInitialLoad && (to.path === '/' || to.path === '/login')) {
    const tag = await getDocTag()
    next(tag === 'face' ? '/forecast' : '/download')
    return
  }

  next()
})

export default router